var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, "Banner List") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21,10a2.2489,2.2489,0,0,1,.4087.0415.5072.5072,0,0,0,.4111-.1074A.4992.4992,0,0,0,22,9.55V7.5A2.503,2.503,0,0,0,19.5,5H4.5A2.503,2.503,0,0,0,2,7.5V9.55a.5.5,0,0,0,.5913.4917A2.2489,2.2489,0,0,1,3,10a2,2,0,0,1,0,4,2.2489,2.2489,0,0,1-.4087-.0415.5073.5073,0,0,0-.4111.1074A.4992.4992,0,0,0,2,14.45V16.5A2.503,2.503,0,0,0,4.5,19h15A2.503,2.503,0,0,0,22,16.5V14.45a.4992.4992,0,0,0-.18-.3843.5081.5081,0,0,0-.4111-.1074A2.2489,2.2489,0,0,1,21,14a2,2,0,0,1,0-4Zm0,5v1.5A1.5017,1.5017,0,0,1,19.5,18H4.5A1.5017,1.5017,0,0,1,3,16.5V15A3,3,0,0,0,3,9V7.5A1.5017,1.5017,0,0,1,4.5,6h15A1.5017,1.5017,0,0,1,21,7.5V9a3,3,0,0,0,0,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5,9v1a.5.5,0,0,1-1,0V9a.5.5,0,0,1,1,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5,14v1a.5.5,0,0,1-1,0V14a.5.5,0,0,1,1,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.945d256875cfa93a4ff9bf115b0ff964.svg";
export { ForwardRef as ReactComponent };